import { Box, Typography } from '@mui/material';

const ColorLine = ({ color, noOffset }) => {
  const isHexColor = /^#([0-9A-F]{3}|[0-9A-F]{6})$/i.test(color || '');

  return (
    <Box
      sx={{
        backgroundColor: isHexColor ? color : `${color}.main`,
        width: '80%',
        height: 10,
        borderRadius: '10px',
        mb: 1,
        justifySelf: 'center'
      }}></Box>
  );
};

export default ColorLine;
